import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202511: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202511",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-11-01",
  endDate: "2025-11-30",
  impressions: 4400,
  clicks: 89,
  adsSpendDollars: 260,
  budgetDollars: 600,
  salesDollars: 781,
  bestEstimateRoas: 3,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.43,
  reorderConversions: 3,
  dataAvailableAtDate: "2025-12-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
